import type { JointOrAilment, PrimaryJoint } from "api/schemas/Patients";

export const stringifyJoint = (joint: PrimaryJoint): string => {
  const { lateral_location, location } = joint;

  return `${location}_${lateral_location}`;
};

export const getTreatmentId = (treatment: JointOrAilment): string => {
  return treatment.ailment === "joint_pain" && treatment.joint?.location && treatment.joint?.lateral_location
    ? stringifyJoint({
        location: treatment.joint.location,
        lateral_location: treatment.joint.lateral_location,
      })
    : treatment.ailment;
};
